import { ETurboModeLevels, ITurboModeState } from '@GFTypes/GameStoreTypes/SpinParameters';

export const TURBO_MODE_STATE_DEFAULTS: ITurboModeState = {
    active: false,
    baseGameLevel: ETurboModeLevels.NORMAL,
    specialGameLevel: undefined,
    animationsSpeedPerLevel: [1, 1, 1.5],
    winSpeedPerLevel: [1, 1, 1.5],
    deactivateTurboInFG: true
};
